var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen ct-flex-column"},[_c('TheHeader',{staticClass:"the-header"}),_c('router-view',{staticClass:"item-flex-full"}),_c('TheToast'),_c('TheLoading'),_c('Confirm'),_c('Alerte'),_c('Prompt'),_c('Select')],1)}
var staticRenderFns = []

export { render, staticRenderFns }